// Tickable Mail: flows texts (en)
export default {
  "mail_flow_filter_exclude_events": "Not for these activities",
  "mail_flow_no_exceptions": "No exceptions",
  "mail_flow_filter_except_events": "except at {names}",
  "mail_flow_how_it_works": "How does this work?",
  "mail_flow_filter_toggle": "Only for certain visitors",
  "mail_flow_turn_on": "Turn on",
  "mail_flow_turn_off": "Turn off",
  "mail_flow_go_live": "Put changes live",
  "mail_flow_state_on": "On",
  "mail_flow_state_off": "Off",
  "mail_flow_state_saving": "saving",
  "mail_flow_state_changes": "changes not live yet",
  "mail_event_reminder": "Reminder beforehand",
  "mail_event_reminder_text": "Everything in one place, two days before the visit.",
  "mail_event_thanks": "Thank-you afterwards",
  "mail_event_thanks_text": "A thank-you, only for those who came.",
  "mail_event_adjust": "Adjust",
  // list
  "mail_flow_list_intro": "Mails that go out by themselves: a reminder just before the visit, a thank-you afterwards. Everything counts from each order's own timeslot.",
  "mail_flow_new": "New automation",
  "mail_flow_list_empty_title": "No automations yet",
  "mail_flow_list_empty_detail": "Start with a reminder just before the visit. It's ready in a minute.",
  "mail_flow_load_failed": "Couldn't load the automations.",
  "mail_flow_retry": "Try again",
  "mail_flow_has_changes": "Changes not published yet",
  "mail_flow_toggle_label": "Turn {name} on or off",
  "mail_flow_delete_label": "Delete {name}",
  "mail_flow_delete_title": "Delete automation?",
  "mail_flow_delete_message": "{name} goes away, along with everyone in it. Mails already sent stay in your overview.",
  "mail_flow_delete_waiting": "{n} person is still in {name}. They won't get anything more from this automation. | {n} people are still in {name}. They won't get anything more from this automation.",
  "mail_flow_delete_accept": "Delete",
  "mail_flow_delete_failed": "Couldn't delete",
  "mail_flow_readonly": "You can view automations, but not change them. Ask your organization's owner for the 'Edit mail' right.",

  // new
  "mail_flow_new_title": "New automation",
  "mail_flow_new_start_from": "What do you want to start with?",
  "mail_flow_new_template_standard": "Leave it empty for the standard mail. You can adjust it afterwards.",
  "mail_flow_send_standard": "The standard mail",
  "mail_flow_new_template_later": "Not sure yet? Leave it empty, you can pick the mail later in the editor.",
  "mail_flow_new_create": "Create",
  "mail_flow_create_failed": "Couldn't create it",
  "mail_flow_starter_reminder": "Reminder beforehand",
  "mail_flow_starter_reminder_text": "2 days before the visit at 10:00, a mail with everything in one place.",
  "mail_flow_starter_thanks": "Thank-you afterwards",
  "mail_flow_starter_thanks_text": "3 hours after the first scan, a thank-you, only for people who actually came.",
  "mail_flow_starter_payment_reminder": "Payment reminder",
  "mail_flow_starter_payment_reminder_text": "24 hours before a reservation expires, a reminder if it's still unpaid, plus a notification for you.",
  "mail_flow_starter_welcome": "Welcome after signup",
  "mail_flow_starter_welcome_text": "A welcome mail as soon as someone signs up for your news.",
  "mail_flow_starter_empty": "Empty",
  "mail_flow_starter_empty_text": "Build it yourself, step by step.",

  // editor
  "mail_flow_not_found": "This automation doesn't exist (anymore)",
  "mail_flow_not_found_detail": "Someone may have deleted it, or it belongs to another organization.",
  "mail_flow_back_to_list": "Go to your automations",
  "mail_flow_name": "Name",
  "mail_flow_name_required": "Give your automation a name",
  "mail_flow_save": "Save",
  "mail_flow_save_failed": "Couldn't save",
  "mail_flow_publish": "Go live",
  "mail_flow_publish_failed": "Couldn't publish",
  "mail_flow_published_live": "Published. Applies to orders from now on",
  "mail_flow_published_others": "{n} person is still in the previous version | {n} people are still in the previous version",
  "mail_flow_unsaved": "You have changes that aren't saved yet. Leave anyway?",
  "mail_flow_empty_title": "Add your first step",
  "mail_flow_empty_detail": "For example: wait until 2 days before the visit, then send a reminder.",
  "mail_flow_add_first_step": "Add step",
  "mail_flow_add_after": "Add step after: {step}",
  "mail_flow_add_in_branch": "Add step under {branch}",
  "mail_flow_moved": "Moved: {step}. Now step {n} of {total}.",
  "mail_flow_limits": "{steps} of {maxSteps} steps · {sends} of {maxSends} mails",
  "mail_flow_limit_steps_hint": "An automation has at most {max} steps",
  "mail_flow_limit_sends_hint": "An automation sends at most {max} mails",
  "mail_flow_add_if_middle_hint": "The steps below move under Yes",
  "mail_flow_add_exit_middle_hint": "Stop can only go at the bottom",
  "mail_flow_keyboard_hint": "With the keyboard: Enter opens a step, Delete removes it, Alt + arrow moves it.",
  "mail_flow_panel_trigger": "Who gets in",
  "mail_flow_close": "Close",
  "mail_flow_cancel": "Back",
  "mail_flow_yes": "Yes",
  "mail_flow_no": "No",
  "mail_flow_branch_empty": "it stops here",
  "mail_flow_remove_title": "Remove step?",
  "mail_flow_new_other_mail": "Pick another mail",
  "mail_flow_removed": "\"{step}\" was removed.",
  "mail_flow_wait_add_hours": "Hours and minutes",
  "mail_flow_tag_placeholder_enter": "Type a tag and press Enter",
  "mail_flow_remove_if_message": "This condition will be removed, and so will the step under Yes and No. | This condition will be removed, and so will the {n} steps under Yes and No.",
  "mail_flow_remove_accept": "Remove",
  "mail_flow_step_remove": "Remove step",
  "mail_flow_problem_no_template": "Pick a mail",
  "mail_flow_problem_no_rules": "Add a condition",
  "mail_flow_problem_no_tag": "Pick the tag that starts it",

  // on / off
  "mail_flow_turned_on": "It's on",
  "mail_flow_off_title": "Turn off?",
  "mail_flow_off_waiting": "1 person is still waiting for this mail. They won't get it then. | {n} people are still waiting for this mail. They won't get it then.",
  "mail_flow_on_title": "Turn on {name}",
  "mail_flow_on_existing": "Also for the one person who already has tickets | Also for the {n} people who already have tickets",
  "mail_flow_on_first": "The first one goes {day} at {time}",
  "mail_flow_turned_on_existing": "1 person who already had tickets gets it too. | {n} people who already had tickets get it too.",
  "mail_flow_enroll_failed": "It's on, but people who already had tickets couldn't be added. Turn it off and on again to retry.",
  "mail_flow_trigger_locked": "Turn it off first if you want to change this.",
  "mail_flow_back_to_flow": "Back to the automatic mail",
  "mail_flow_new_mail_name": "New mail",
  "mail_flow_toggle_failed": "Couldn't turn it on or off",

  // counts
  "mail_flow_count_waiting": "{n} waiting | {n} waiting",
  "mail_flow_count_waiting_here": "{n} waiting here | {n} waiting here",
  "mail_flow_count_done": "{n} done | {n} done",
  "mail_flow_count_sent": "{n} sent | {n} sent",
  "mail_flow_count_skipped": "{n} skipped | {n} skipped",

  // step types
  "mail_flow_type_send": "Mail",
  "mail_flow_type_wait": "Wait",
  "mail_flow_type_if": "If…",
  "mail_flow_type_tag": "Tag",
  "mail_flow_type_notify_team": "Notify your team",
  "mail_flow_type_exit": "Stop",

  // step texts
  "mail_flow_step_send_text": "Send: {name}",
  "mail_flow_step_send_empty": "Send: no mail picked yet",
  "mail_flow_template_missing": "a mail that no longer exists",
  "mail_flow_step_if_text": "If: {condition}",
  "mail_flow_condition_empty": "no condition yet",
  "mail_flow_step_tag_add": "Add tag {tags}",
  "mail_flow_step_tag_remove": "remove tag {tags}",
  "mail_flow_step_tag_empty": "Tag: nothing set yet",
  "mail_flow_step_notify_text": "Notify your team",
  "mail_flow_step_exit_text": "Stop",
  "mail_flow_no_steps_short": "no steps yet",
  "mail_flow_and": "and",
  "mail_flow_or": "or",
  "mail_flow_unknown_item": "(deleted)",
  "mail_flow_n_more": "{n} more | {n} more",
  "mail_flow_n_days": "{n} day | {n} days",
  "mail_flow_n_hours": "{n} hour | {n} hours",
  "mail_flow_n_minutes": "{n} minute | {n} minutes",

  // wait texts
  "mail_flow_wait_for": "Wait {duration}",
  "mail_flow_wait_for_at": "Wait {duration}, then until {time}",
  "mail_flow_wait_until_time": "Wait until it's {time}",
  "mail_flow_wait_nothing": "Wait: nothing set yet",
  "mail_flow_wait_days_before_visit": "Wait until {days} before the visit, at {time}",
  "mail_flow_wait_visit_day": "Wait until the day of the visit, at {time}",
  "mail_flow_wait_after_first_scan": "Wait until {hours} after the first scan",
  "mail_flow_wait_after_visit_end": "Wait until {days} after the visit, at {time}",
  "mail_flow_wait_before_reservation_expires": "Wait until {hours} before the reservation expires",

  // wait panel
  "mail_flow_wait_how": "How long to wait?",
  "mail_flow_wait_mode_for": "A fixed time",
  "mail_flow_wait_mode_visit": "Around the visit",
  "mail_flow_wait_visit_needs_order": "Waiting around the visit only works when the automation starts with an order.",
  "mail_flow_unit_days": "Days",
  "mail_flow_unit_hours": "Hours",
  "mail_flow_unit_minutes": "Minutes",
  "mail_flow_wait_at_time_toggle": "Then wait until a set time",
  "mail_flow_wait_time": "Time",
  "mail_flow_wait_for_hint": "With a set time, the next step happens the next time the clock reaches it. Handy so nobody gets mail in the middle of the night.",
  "mail_flow_wait_until_label": "Until when?",
  "mail_flow_until_days_before_visit": "A number of days before the visit",
  "mail_flow_until_after_first_scan": "A number of hours after the first scan",
  "mail_flow_until_after_visit_end": "A number of days after the visit",
  "mail_flow_until_before_reservation_expires": "A number of hours before the reservation expires",
  "mail_flow_until_days_before_visit_hint": "We count from each order's own timeslot. With 300 timeslots, everyone gets the reminder for their own visit, and if you move a slot, the reminder moves with it. For tickets valid for several days we skip this reminder. An order without a timeslot doesn't take part.",
  "mail_flow_until_after_first_scan_hint": "The moment is the order's first scan, so for open museum tickets it's the real visit. Not scanned? Then we count from the end of the timeslot, but only for one-day tickets. That way people who don't scan still get a thank-you. To skip no-shows, put 'If: scanned' below it.",
  "mail_flow_until_after_visit_end_hint": "We count from the end of the order's timeslot. For tickets valid for several days we skip this.",
  "mail_flow_until_before_reservation_expires_hint": "For reservations with a payment deadline. If the reservation might already be paid, catch that with an 'If…' below.",
  "mail_flow_wait_missed_hint": "Has this moment already passed when someone gets here, for example because they order today for tomorrow? Then we skip the mail right after it.",

  // send panel
  "mail_flow_send_which": "Which mail?",
  "mail_flow_send_pick": "Pick a mail",
  "mail_flow_send_pick_hint": "Pick a mail, otherwise you can't publish.",
  "mail_flow_send_no_templates": "You don't have any mails yet. Make one first.",
  "mail_flow_send_marketing_hint": "This is a newsletter mail. It only goes to people who gave consent, and at most one a day to the same address.",
  "mail_flow_send_edit": "Edit this mail",
  "mail_flow_send_new": "Make a new mail",

  // if panel
  "mail_flow_if_when": "When is it Yes?",
  "mail_flow_op_all": "All of them",
  "mail_flow_op_any": "Any of them",
  "mail_flow_rule_type": "Condition",
  "mail_flow_rule_not": "Is or isn't",
  "mail_flow_rule_is": "Is",
  "mail_flow_rule_is_not": "Isn't",
  "mail_flow_rule_remove": "Remove condition",
  "mail_flow_rule_add": "Add condition",
  "mail_flow_rule_compare": "Comparison",
  "mail_flow_rule_days": "Number of days",
  "mail_flow_days_word": "days",
  "mail_flow_compare_lt": "less than",
  "mail_flow_compare_lte": "at most",
  "mail_flow_compare_gt": "more than",
  "mail_flow_compare_gte": "at least",
  "mail_flow_if_hint": "Yes and No each go their own way and don't come back together. Leave a side empty and it stops there.",
  "mail_flow_pick_ticket_types": "Pick ticket types",
  "mail_flow_pick_events": "Pick activities",
  "mail_flow_pick_language": "Pick a language",
  "mail_flow_rule_scanned": "Scanned",
  "mail_flow_rule_ticket_type": "Ticket type",
  "mail_flow_rule_event": "Activity",
  "mail_flow_rule_refunded": "Refunded",
  "mail_flow_rule_language": "Language",
  "mail_flow_rule_has_tag": "Has a tag",
  "mail_flow_rule_has_consent": "Consent for newsletters",
  "mail_flow_rule_has_other_future_event": "Also has tickets for another activity",
  "mail_flow_rule_days_until_visit": "Days until the visit",
  "mail_flow_rule_reservation_paid": "Reservation paid",
  "mail_flow_rule_scanned_text": "scanned",
  "mail_flow_rule_scanned_not_text": "not scanned",
  "mail_flow_rule_refunded_text": "(partly) refunded",
  "mail_flow_rule_refunded_not_text": "not refunded",
  "mail_flow_rule_has_consent_text": "has consent for newsletters",
  "mail_flow_rule_has_consent_not_text": "no consent for newsletters",
  "mail_flow_rule_has_other_future_event_text": "also has tickets for another, later activity",
  "mail_flow_rule_has_other_future_event_not_text": "no tickets for another, later activity",
  "mail_flow_rule_reservation_paid_text": "reservation paid",
  "mail_flow_rule_reservation_paid_not_text": "reservation not paid yet",
  "mail_flow_rule_ticket_type_text": "with ticket {names}",
  "mail_flow_rule_ticket_type_not_text": "without ticket {names}",
  "mail_flow_rule_event_text": "for {names}",
  "mail_flow_rule_event_not_text": "not for {names}",
  "mail_flow_rule_language_text": "language is {name}",
  "mail_flow_rule_language_not_text": "language isn't {name}",
  "mail_flow_rule_has_tag_text": "has tag {tag}",
  "mail_flow_rule_has_tag_not_text": "doesn't have tag {tag}",
  "mail_flow_rule_days_lt_text": "less than {n} day until the visit | less than {n} days until the visit",
  "mail_flow_rule_days_lte_text": "at most {n} day until the visit | at most {n} days until the visit",
  "mail_flow_rule_days_gt_text": "more than {n} day until the visit | more than {n} days until the visit",
  "mail_flow_rule_days_gte_text": "at least {n} day until the visit | at least {n} days until the visit",
  "mail_flow_rule_not_prefix": "not {text}",

  // tag panel
  "mail_flow_tag_add_label": "Add tags",
  "mail_flow_tag_remove_label": "Remove tags",
  "mail_flow_tag_hint": "The tag goes on the visitor's contact. If they aren't a contact yet, we skip this step.",
  "mail_flow_tag_name": "Tag",
  "mail_flow_tag_placeholder": "for example vip",

  // notify panel
  "mail_flow_notify_text_nl": "Text (Dutch)",
  "mail_flow_notify_text_en": "Text (English)",
  "mail_flow_notify_hint": "Your team gets this as a notification, with the visitor's name and e-mail address and a link to the order. You choose how often you get notifications.",
  "mail_flow_notify_settings": "Go to your notifications",

  // exit panel
  "mail_flow_exit_hint": "The automation stops here for this person. Nothing comes after it.",

  // trigger
  "mail_flow_trigger_label": "When does it start?",
  "mail_flow_trigger_order_paid": "Someone buys tickets",
  "mail_flow_trigger_reservation_created": "A reservation is made",
  "mail_flow_trigger_first_scan": "A ticket is scanned for the first time",
  "mail_flow_trigger_signup_confirmed": "Someone signs up for your news",
  "mail_flow_trigger_tag_added": "Someone gets a tag",
  "mail_flow_trigger_event_published": "You publish a new activity",
  "mail_flow_trigger_manual": "You add people yourself",
  "mail_flow_trigger_order_paid_sentence": "When someone buys tickets",
  "mail_flow_trigger_reservation_created_sentence": "When a reservation is made",
  "mail_flow_trigger_first_scan_sentence": "When a ticket is scanned for the first time",
  "mail_flow_trigger_signup_confirmed_sentence": "When someone signs up for your news",
  "mail_flow_trigger_tag_added_sentence": "When someone gets the tag {tag}",
  "mail_flow_trigger_event_published_sentence": "When you publish a new activity",
  "mail_flow_trigger_manual_sentence": "When you add people yourself",
  "mail_flow_trigger_order_paid_hint": "As soon as an order is paid. Anyone who gets a full refund drops out by themselves.",
  "mail_flow_trigger_reservation_created_hint": "As soon as you make a reservation with a payment link, before it's paid.",
  "mail_flow_trigger_first_scan_hint": "At the first scan of an order, so once per order, even if it holds more tickets.",
  "mail_flow_trigger_signup_confirmed_hint": "When someone signs up through your form and confirms it in the confirmation mail.",
  "mail_flow_trigger_tag_added_hint": "As soon as a contact gets this tag.",
  "mail_flow_trigger_event_published_hint": "All contacts who gave consent for newsletters get in.",
  "mail_flow_trigger_manual_hint": "Nobody gets in by themselves: you put a group of contacts in the automation yourself.",
  "mail_flow_trigger_live_hint": "What you change here only applies once you publish it. Which activities take part applies right away.",

  "mail_flow_filter_title": "Only for",
  "mail_flow_filter_intro": "Leave empty to include everyone.",
  "mail_flow_filter_events": "Activities",
  "mail_flow_filter_ticket_types": "Ticket types",
  "mail_flow_filter_channels": "How it was ordered",
  "mail_flow_filter_languages_label": "Languages",
  "mail_flow_filter_min_days_label": "Ordered early",
  "mail_flow_filter_min_days_suffix": "days or more before the visit",
  "mail_flow_filter_min_days_hint": "Handy for an extra reminder to people who ordered long in advance. Looks at the order's timeslot.",
  "mail_flow_all_events": "All activities",
  "mail_flow_all_ticket_types": "All ticket types",
  "mail_flow_all_channels": "Any way",
  "mail_flow_all_languages": "All languages",
  "mail_flow_no_ticket_types": "No ticket types found",
  "mail_flow_not_set": "—",
  "mail_flow_filter_for_events": "for {names}",
  "mail_flow_filter_with_ticket_types": "with ticket {names}",
  "mail_flow_filter_via_channels": "via {names}",
  "mail_flow_filter_min_days": "ordered at least {n} day ahead | ordered at least {n} days ahead",
  "mail_flow_filter_languages": "in {names}",
  "mail_flow_channel_shop": "the shop",
  "mail_flow_channel_import": "import",
  "mail_flow_channel_api": "the API",
  "mail_flow_channel_swapped": "TicketSwap",
  "mail_flow_channel_reservation": "a reservation",
  "mail_flow_channel_waitlist": "the waitlist",
  "mail_flow_channel_guest": "the guest list",
  "mail_flow_channel_pos": "the box office",
  "mail_flow_channel_moved": "moved tickets",


  // publish errors
  "mail_flow_error_unknown": "Something went wrong ({message}). Please try again.",
  "mail_flow_error_not_allowed": "You don't have the right to publish automations.",
  "mail_flow_error_mail_flow_not_found": "This automation no longer exists.",
  "mail_flow_error_mail_flow_step_without_id": "There's a step without an id. Remove the step you added last and add it again.",
  "mail_flow_error_mail_flow_duplicate_step_id": "Two steps have the same id. Remove one of the duplicates and add it again.",
  "mail_flow_error_mail_flow_unknown_step": "There's a step we don't recognize. Remove it and try again.",
  "mail_flow_error_mail_flow_if_not_last": "Nothing can come after an 'If…', only inside Yes or No. Move the steps below it into one of them.",
  "mail_flow_error_mail_flow_send_without_template": "One of the mail steps has no mail picked yet.",
  "mail_flow_error_mail_flow_wait_too_long": "A wait step lasts at most 365 days.",
  "mail_flow_error_mail_flow_too_many_steps": "An automation has at most 25 steps. Remove a few.",
  "mail_flow_error_mail_flow_too_many_sends": "An automation sends at most 8 mails. Remove a few.",
  "mail_flow_error_mail_flow_unknown_template": "One of the picked mails no longer exists. Pick another one.",

  // event page
  "mail_flow_event_title": "Automatic mails",
  "mail_flow_event_intro": "Which emails visitors of this activity get by themselves.",
  "mail_flow_event_classic": "You're still using the classic ticket mails, so no automations are running.",
  "mail_flow_event_classic_link": "See what switching gives you",
  "mail_flow_event_only_this": "Only this activity",
  "mail_flow_event_all": "See all automations",
}
